module.exports = __webpack_public_path__ + "account/assets/ref-loading-icon.39b5fd2e.svg";